import { OccConfig } from '@spartacus/core';

export const knBrCheckoutEndpointsConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        // tslint:disable:max-line-length
        addresses: 'knbr/customers/${customerId}/addresses',
        addressDetail: 'knbr/customers/${customerId}/addresses/${addressId}',
        addressVerification: 'knbr/customers/${customerId}/addresses/verification',
      },
    },
  },
};
